/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentProcedure from './treatment-procedure';
import TreatmentProcedureDetail from './treatment-procedure-detail';
import TreatmentProcedureUpdate from './treatment-procedure-update';
import TreatmentProcedureDeleteDialog from './treatment-procedure-delete-dialog';

const TreatmentProcedureRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentProcedure />} />
    <Route path="new" element={<TreatmentProcedureUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentProcedureDetail />} />
      <Route path="edit" element={<TreatmentProcedureUpdate />} />
      <Route path="delete" element={<TreatmentProcedureDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentProcedureRoutes;
